import React from 'react';
import { Sparkles, Tag } from 'lucide-react';

// Derived from the brand accent (--primary) rather than a fixed hex, so the
// offer treatment tracks the theme instead of drifting from it.
export const OFFER_GRADIENT =
  'linear-gradient(135deg, hsl(var(--primary)) 0%, hsl(var(--primary) / 0.78) 100%)';

export const OfferBanner = ({ venue, compact = false }) => {
  if (!venue?.offer_enabled) return null;

  const validUntil = venue.offer_valid_until
    ? new Date(venue.offer_valid_until).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    : null;

  if (compact) {
    return (
      <div
        className="relative overflow-hidden rounded-lg mb-3 px-3 py-2 text-white shadow-sm"
        style={{ background: OFFER_GRADIENT }}
        data-testid="space-offer-banner"
      >
        <div className="flex items-center gap-1.5 flex-wrap">
          <Sparkles className="w-3.5 h-3.5 shrink-0" />
          <span className="font-heading font-semibold text-xs">{venue.offer_title || 'Special Offer'}</span>
          {venue.offer_badge && (
            <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide bg-white/20 px-1.5 py-0.5 rounded-full">
              <Tag className="w-2.5 h-2.5" />{venue.offer_badge}
            </span>
          )}
        </div>
        {venue.offer_description && (
          <p className="text-[11px] text-white/90 mt-0.5 line-clamp-2">{venue.offer_description}</p>
        )}
        {validUntil && (
          <p className="text-[10px] text-white/70 mt-0.5">Valid till {validUntil}</p>
        )}
      </div>
    );
  }

  return (
    <div
      className="relative overflow-hidden rounded-2xl mb-8 px-5 py-4 sm:px-6 sm:py-5 flex items-center gap-4 text-white shadow-md"
      style={{ background: OFFER_GRADIENT }}
      data-testid="venue-offer-banner"
    >
      <div className="hidden sm:flex w-11 h-11 rounded-full bg-white/15 items-center justify-center shrink-0">
        <Sparkles className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="font-heading font-semibold text-base sm:text-lg">{venue.offer_title || 'Special Offer'}</h3>
          {venue.offer_badge && (
            <span className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide bg-white/20 px-2 py-0.5 rounded-full">
              <Tag className="w-3 h-3" />{venue.offer_badge}
            </span>
          )}
        </div>
        {venue.offer_description && (
          <p className="text-sm text-white/90 mt-0.5">{venue.offer_description}</p>
        )}
        {validUntil && (
          <p className="text-[11px] text-white/70 mt-1">Valid till {validUntil}</p>
        )}
      </div>
    </div>
  );
};

export default OfferBanner;
